export const HEY_IMMO_CONTROL_GA_PARAMETER = 'PPA-12798-control'
export const HEY_IMMO_TREATMENT_GA_PARAMETER = 'PPA-12798-treatment'

type HeyImmoExperimentTrackingParameters = {
  ga_cd_test_ppa: string
}

type HeyImmoExperimentStateParams = {
  isHeyImmoSupported: boolean
  isHeyImmoFeatureLoadedFromBackend: boolean
  heyImmoFeatureValue: boolean | undefined
}

type HeyImmoExperimentState = {
  trackingParameters?: HeyImmoExperimentTrackingParameters
}

export function getHeyImmoExperimentState({
  isHeyImmoSupported,
  isHeyImmoFeatureLoadedFromBackend,
  heyImmoFeatureValue,
}: HeyImmoExperimentStateParams): HeyImmoExperimentState {
  const isInExperiment = isHeyImmoSupported && isHeyImmoFeatureLoadedFromBackend && heyImmoFeatureValue !== undefined

  if (!isInExperiment) {
    return {}
  }

  return {
    trackingParameters: {
      ga_cd_test_ppa: heyImmoFeatureValue ? HEY_IMMO_TREATMENT_GA_PARAMETER : HEY_IMMO_CONTROL_GA_PARAMETER,
    },
  }
}
